import React from 'react';

const Icon = ({ icon, color }) => {
  return <i className={icon} style={{ color: color }}></i>;
};

export default Icon;
